module.exports = __webpack_public_path__ + "img/Slice6-min.bcdcbc47.png";